import React from 'react'

type Props = {
 id?: string
 title?: string
 className?: string
 text?: string
 children?: React.ReactNode
}
const KTText = ({
 id,
 title,
 className,
 text,
 children,
}: Props) => {
 return (
  <>
   <div
    id={id}
    data-title={title}
    className={`${className} 
            text-[#80868C] text-xs font-normal px-3 py-2            
            `}
   >
    <span className='flex items-center'>
     {children}
     {text}
    </span>
   </div>
  </>
 )
}

KTText.defaultProps = {
 className: 'w-full',
}

export {KTText}
